import React,{useState,useEffect} from 'react'
import { Link, useNavigate } from "react-router-dom";
import { Resolver, SubmitHandler, useForm } from "react-hook-form";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import authQueries from '../../../queries/authQueries';


const validationSchema = yup.object({
    question: yup
      .string('⚠ Enter Question')
      .required('⚠ Question is required')
      .min(2,'⚠ Question must be more than 2 characters '),
  });


const  AddInfo = () => {

    const [errName, setErrName] = useState('')

    const navigate = useNavigate();

    const { register, handleSubmit, formState:{ errors } } = useForm({

        resolver: yupResolver(validationSchema)
    
      });


    const AddInfodata = 

    authQueries.useInfoMutationAdd(

        (response) => {

            if(response?.message === "Success"){
                navigate('/listinfo')
            }else if(response?.error[0].question){
                setErrName("⚠ "+response?.error[0].question)
            }

        }
    );


    const onSubmit = (data) => {

    
        const datavalues = {
            question: data.question,
            status: "ACTIVE",
    
        };
    
        AddInfodata.mutateAsync(datavalues);    
    
      }


  return (

    <div>

        <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
            <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
            <li className="breadcrumb-item"><Link to="/listinfo">Additional Information</Link></li>
            <li className="breadcrumb-item active" aria-current="page">Add Information</li>
            </ol>
        </nav>

        <div className="add_clients">

                <div className="card">
                    <div className="card-header">
                        Add Information
                    </div>
                    <div id="travel_history" className="collapse show" data-parent="#accordion">

                        <div className="card-body">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className='form-group'>
                                            <div id='parent' className='form-group'>
                                                <label htmlFor="">Question</label>
                                                <input className="form-control"  {...register("question")} type="text" name='question' />
                                                <div className='error-msg'>{errors.question?.message} {errName}</div>
                                            </div>
                                        </div>
                                    </div>        
                                </div>
                                
                                <div className="row">
                                    <div className="col-md-12 text-center">
                                        <button type='submit' className="btn btn-default btn-save">Submit</button>
                                    </div>
                                </div>
                            </form>                            
                        </div>
                    </div>
                </div>
        </div>

    </div>

  )

}

export default AddInfo